import type { TrackingData } from "./types/tracking";
import type { JSONQuery } from "./types/suggestion";

export enum MARK {
  SUGGEST_TIME_START = "suggest_time_start",
  SUGGEST_TIME = "suggest_time",
  EMPTY_STATE_TIME_START = "empty_state_time_start",
  EMPTY_STATE_TIME = "empty_state_time",
  INITIAL_SEARCH_BOX_TIME = "initial_search_box_time",
  SUGGEST_RENDER_TIME_START = "suggest_render_time_start",
  SUGGEST_RENDER_TIME = "suggest_render_time",
}

export enum SELECTOR {
  LAYER = ".js_squirrel_searchSuggestionsContainer",
  SEARCH_CONTAINER = ".js_squirrel_searchContainer",
  SEARCH_WRAPPER = ".squirrel_searchbarWrapper",
  SEARCH_FORM = ".js_squirrel_searchForm",
  SEARCH_ICON = ".js_squirrel_searchIcon",
  HEADER_ELEMENT = ".js_find_header",
  SUGGEST_TERM = ".js_squirrel_searchSuggest",
  ABORT_BUTTON = ".js_squirrel_searchline__abort",
  CURTAIN = ".js_squirrel_searchCurtain",
  DELETE_BUTTON = ".js_squirrel_searchbar__delete",
  SUBMIT_BUTTON = ".js_squirrel_searchbar__submit",
  SEARCH_FIELD = ".js_squirrel_searchbar__input",
  SEARCH_TERM = ".js_squirrel_searchSuggest__term",
  MODIFIED_ARROW = ".js_squirrel_searchSuggest__arrow",
  SEARCHBAR = ".js_squirrel_searchbar",
  SELECTED_SEARCH_SUGGEST = ".squirrel_searchSuggest--selected",
  HISTORY = ".js_squirrel_searchHistory",
  HISTORY_TERM = ".js_squirrel_searchHistory__term",
  HISTORY_DELETEALL = ".js_squirrel_searchHistoryDelete",
  HISTORY_EDIT_BUTTON = ".js_squirrel_history_edit_button",
  HISTORY_ITEM_SELECT = ".js_squirrel_select_history_item",
  /*🤫*/
  SEARCH_SUGGEST = ".squirrel_searchSuggest",
  SUGGEST_ITEM = ".squirrel_searchSuggest__text",
}

export enum CLASSNAME {
  SEARCHBAR_WRAPPER_VISIBLE_SUGGESTIONS = "squirrel_searchbarWrapper--visibleSuggestions",
  SEARCHBAR_HEADER_VISIBILITY = "find_header--visibleSearchbar",
  SEARCHBAR_HEADER_ACTIVE = "find_header--activeSearch",
  SELECTED_SEARCH_SUGGEST = "squirrel_searchSuggest--selected",
  IGNORE_CLOSE_SUGGEST = "js_squirrel_ignore_close_suggest",
  HINT = "hint",
  SEARCHBAR_SHOW_BUTTONS = "squirrel_searchbar--showButtons",
  TRACK_MODIFIED = "san_track_modified",
  TRACK_SUGGEST = "san_track_suggest",
}

export enum DATA {
  POS = "data-suggestpos",
  TERM = "data-term",
  TARGET_TERM = "data-target-term",
  TARGET = "data-target",
  ERROR = "data-error",
  SUGGEST_URL = "data-suggestserveruri",
  SUGGEST_SEARCH_TERM = "data-suggest-search-term",
  SUGGEST_WORD_LIST = "data-suggestWordList",
  SUGGEST_WORD_LIST_COUNT = "data-suggestWordListCount",
  SUGGEST_POS = "data-suggestpos",
  ARTICLE_NUMBER_SEARCH = "data-article-number-search",
}

export enum KEY_CODE {
  ENTER = "13",
  ESC = "27",
  ARROW_UP = "38",
  ARROW_DOWN = "40",
  TAB = "9",
}

/*🤫
🤫
🤫
🤫
🤫*/
export function getNextActiveElement(key: string, current: HTMLLIElement): Element | null {
  if (!current) {
    return null;
  }

  switch (key) {
    case KEY_CODE.ARROW_DOWN:
      return current.nextElementSibling as HTMLLIElement;
    case KEY_CODE.ARROW_UP:
      return current.previousElementSibling as HTMLLIElement;
    default:
      return null;
  }
}

/*🤫
🤫
🤫
🤫
🤫*/
export function encode(url: string, json: JSONQuery): string {
  return url + "?" + Object.keys(json).map(param.bind(json)).join("&");
}

/*🤫
🤫
🤫
🤫*/
export function param(this: JSONQuery, key: string): string {
  return encodeURIComponent(key) + "=" + encodeURIComponent(this[key]);
}

export function isCookieBannerEnabled(): boolean {
  if (window.o_util && window.o_util.cookie && window.o_util.cookie.get) {
    return window.o_util.cookie.get("cb") == "1";
  }
  return false;
}

export class SquirrelURL {
  private hashList: string[][];
  private url: URL;

  constructor(action: string) {
    /*🤫*/
    /*🤫*/
    this.url = new URL(action, window.location.origin);
    this.hashList = this.createHashList();
  }

  createHashList(): string[][] {
    return (
      this.url.hash
        .split(/[#&]/)
        .filter((hash: string) => hash.length > 0)
        .map((hash: string) => hash.split(/=/)) || []
    );
  }

  hashItemToString(hashItem: string[]): string {
    return `${hashItem[0]}=${hashItem[1]}`;
  }

  getTrackingParameter(): TrackingData {
    const response: string[][] = this.hashList.filter((hashItem: string[]) => hashItem[0] == "t");
    if (response.length <= 0) {
      return {};
    }
    const trackingValues: string = decodeURIComponent(response[0][1]);
    return JSON.parse(trackingValues);
  }

  getUrlWithoutTrackingParameter(): string {
    const hashes: string = this.hashList
      .filter((hashItem: string[]) => hashItem[0] != "t")
      .map((p): string => this.hashItemToString(p))
      .join("&");
    const hashSymbol: string = hashes.length > 0 ? "#" : "";
    return this.url.origin + this.url.pathname + hashSymbol + hashes || "";
  }
}
